export const GOOGLE_LOGIN = "auth/google-login";
export const SIGNUP = "auth/signup";
export const LOGIN = "auth/login";
export const ACTIVATE = "auth/activate";
export const FORGOT_PASSWORD = "auth/forgot-password";
export const RESET_PASSWORD = "auth/reset-password";
export const TRENDING_HASHTAGS = "/posts/generate-hashtags-from-weekly-trends";
export const GENERATE_IDEA = "/posts/generate-idea";
export const GENERATE_IDEAS_COMBINED = "/posts/generate-ideas-combined";
export const GENERATE_POSTS_COMBINED = "/posts/generate-posts-combined";
export const GENERATE_POSTS_GUEST = "/posts/generate-posts-guest";
export const GENERATE_POST = "/posts/generate-post";
export const GENERATE_QUICK_POST = "/posts/generate-quick-post";
export const CAMPAIGNS = "/campaigns";
export const STATS = "/campaigns/stats/monthly";
export const PLANS = "/plans";
export const PLANS_CURRENT = "/plans/current";
export const PLANS_SUBSCRIBE = "/plans/subscribe";
export const PAYMENTS = "/payments";
export const paymentSessionPath = (sessionId) => `/payments/session/${sessionId}`;
export const POSTS = "/posts";
export const OPPORTUNITIES = "/opportunities";
export const TRENDS = "/trends";
export const GET_PROFILE = "/profile/business-details";
export const POST_BUSINESS_PROFILE = "/profile/business-details";
export const SUGGEST_INDUSTRY_CATEGORY = "/profile/business-details/suggest-industry-category";
export const GET_PROFILE_SETUP = "/profile/business-profile/setup";
